/**
 * Returns the first item whose `hexColor` matches `targetHex` case-insensitively,
 * or `null` when no item matches (including when `targetHex` is nullish).
 *
 * Used to keep fabric and frame visually aligned: when one is picked we look
 * for the same hex in the other list, so the configured product mirrors the
 * kozijn.
 */
export function findColorByHex<T extends { hexColor: string | null }>(
    items: T[],
    targetHex: string | null | undefined,
): T | null {
    if (!targetHex) return null;
    const target = targetHex.toLowerCase();
    return items.find((c) => c.hexColor?.toLowerCase() === target) ?? null;
}
